import { bannerBox } from '../../../components/BannerBox/tokens/bluestone/ED';
import { deprecatedButton } from '../../../deprecated/Button/tokens/bluestone/ED';
import type { ComponentTokens } from '../types';
import { baseComponents } from './base';

export const components: ComponentTokens = {
  ...baseComponents,
  bannerBox,
  deprecatedButton,
};
